
<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-10">
                <div class="float-right"> 
                    <button class= "dash-btns btn mr-3"  [routerLink]="['/PayOut/PayoutLedgers']">Manage Payout Ledgers</button>
                       
                    <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>



                </div>
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div>
                                <div class="text-center">
                                    <a class="view-h gary-t  "> Payout Ledgers </a>
                                    
                                </div>

                                <div class="pt-3">
                                    <div class=" ">
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>TransactionType</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.TransactionType}}
                                                                             </div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Entry</label> </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.Entry}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>EntryDetail</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.EntryDetail}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> Amount</label></div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.Amount}}</div>
                                        </div>
                                      
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>Status </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.Status}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"><label> Balance </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.Balance}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> Notes </label>  </div>
                                            
                                            <div class="col-7 p-0 view-text"> {{rows.Notes}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label> FundingDetail</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot">   {{rows.FundingDetail }}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-4 p-0"> <label>UpdatedDateTime</label>  </div>
                                            
                                            <div class="col-7 p-0 view-text robot"> {{rows.UpdatedDateTime | date:'d/M/yy, h:mm a'}}</div>
                                        </div>
                                      
                                         
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="text-center">
                      <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
                    </div>
                  </div>
            </div>
        </div>
    </section>
</div>



  
 